import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchCollection_pointsReorder = z.any()
export type TagsPatchCollection_pointsReorder = z.infer<typeof tagsPatchCollection_pointsReorder>

export const bodyPatchCollection_pointsReorder = z.object({ "updates": z.array(z.object({ "id": z.string(), "order": z.number() })) })
export type BodyPatchCollection_pointsReorder = z.infer<typeof bodyPatchCollection_pointsReorder>

export const responsePatchCollection_pointsReorder = z.any()
export type ResponsePatchCollection_pointsReorder = z.infer<typeof responsePatchCollection_pointsReorder>

interface IPatchCollection_pointsReorder extends BaseMethodType {
  tags: TagsPatchCollection_pointsReorder,
  body: BodyPatchCollection_pointsReorder,
  response: ResponsePatchCollection_pointsReorder
}
export const URL = '/collection-points/reorder'
export const validation = {
  patch: {
    tags: tagsPatchCollection_pointsReorder,
    body: bodyPatchCollection_pointsReorder,
    response: responsePatchCollection_pointsReorder
  }
}
export interface Collection_pointsReorder extends BaseRouteType {
  patch: IPatchCollection_pointsReorder
}